/// <amd-module name="Reporting/VelocityReport/VelocityReportTeachingBubbleHelper" />
import { ReportGuidedTourUtilityProps } from "Reporting/BoardsCommon/ReportGuidedTourUtility";
import * as Resources from "Reporting/VelocityReport/Resources";
import { getVelocityReportSettingsStorageKey } from "./VelocityReportUserSettings";

export function getTeachingBubblesData(): ReportGuidedTourUtilityProps {
    return {
        reportKey: getVelocityReportSettingsStorageKey(),
        tourBubble: {
            title: Resources.TourBubbleTitle,
            text: Resources.TourBubbleText
        },
        filterBubble: {
            title: Resources.FilterBubbleTitle,
            text: Resources.FilterBubbleText
        },
        chartBubble: {
            title: Resources.ChartBubbleTitle,
            text: Resources.ChartBubbleText
        },
        legendBubble: {
            title: Resources.LegendBubbleTitle,
            text: Resources.LegendBubbleText
        },
        reportDocumentationUrl: "https://go.microsoft.com/fwlink/?linkid=2095910"
    };
}
